<!-- 资料变更历史 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <v-search v-if="formList.drugInformation.length > 0" :searchList="formList.drugInformation" :getRequestData="getRequestData" @searchData="searchData" @openSearchs="openSearch"></v-search>
         </div>
      </div>
      <div class="page_content_center">
         <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
            <el-table-column align="center" label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="location" label="发生地区" show-overflow-tooltip min-width="180"></el-table-column>
            <el-table-column align="center" prop="useUnit" label="使用单位" show-overflow-tooltip min-width="180"></el-table-column>
            <el-table-column align="center" prop="useNum" label="用药人数" show-overflow-tooltip min-width="130"></el-table-column>
            <el-table-column align="center" prop="badNum" label="发生不良事件人数" show-overflow-tooltip min-width="180"></el-table-column>
            <el-table-column align="center" prop="serBadNum" label="严重不良事件人数" show-overflow-tooltip min-width="180"></el-table-column>
            <el-table-column align="center" prop="deadNum" label="死亡人数" show-overflow-tooltip min-width="130"></el-table-column>
            <el-table-column align="center" prop="firstMadeDate" label="首例用药日期" show-overflow-tooltip min-width="150"></el-table-column>
            <el-table-column align="center" prop="firstOccurDate" label="首例发生日期" show-overflow-tooltip min-width="150"></el-table-column>
            <el-table-column align="center" prop="badPerfor" label="不良事件表现" show-overflow-tooltip min-width="150"></el-table-column>
            <el-table-column align="center" prop="unitName" label="报告单位" show-overflow-tooltip min-width="130"></el-table-column>
            <el-table-column align="center" prop="repOpin" label="报告单位意见" show-overflow-tooltip min-width="200"></el-table-column>
            <el-table-column align="center" prop="repDate" label="报告日期" show-overflow-tooltip min-width="130"></el-table-column>
            <el-table-column align="center" prop="createTime" label="创建时间" show-overflow-tooltip min-width="120">
               <template slot-scope="scope">
                  <span v-if="scope.row.createTime">
                     {{ $common.getLocalTime(scope.row.createTime) }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog title="药品群体不良事件基本信息表" v-if="drugShow" center :visible.sync="drugShow" width="1200px" top="10px">
         <div class="box">
            <!-- <p>
               <span>编号：YMYY-【ZLZD-020】-JL001-01</span>
            </p> -->
            <p class="floor_bottom align_items_end">
               <span class="li_title">报告日期：</span>
               <el-date-picker v-model="drugObj.repDate" type="date" placeholder="选择日期" format="yyyy年MM月dd日" size="mini" value-format="yyyy-MM-dd"></el-date-picker>
            </p>
            <div class="box_center">
               <ul class="ul">
                  <li class="li ul_li align_items_center">
                     <span class="li_title">发生地区：</span>
                     <el-input clearable v-model="drugObj.location" class="input" size="mini"></el-input>
                  </li>
                  <li class="li ul_li align_items_center">
                     <span class="li_title">使用单位：</span>
                     <el-input clearable class="input" v-model="drugObj.useUnit" size="mini"></el-input>
                  </li>
                  <li class="li ul_li align_items_center">
                     <span class="li_title">用药人数：</span>
                     <el-input clearable class="input" type="number" v-model.trim="drugObj.useNum" size="mini"></el-input>
                  </li>
               </ul>
               <ul class="ul">
                  <li class="li ul_li1 align_items_start">
                     <span class="li_title">发生不良事件人数：</span>
                     <el-input clearable class="input" v-model="drugObj.badNum" size="mini"></el-input>
                  </li>
                  <li class="li ul_li1 align_items_start">
                     <span class="li_title">严重不良事件人数：</span>
                     <el-input clearable class="input" v-model="drugObj.serBadNum" size="mini"></el-input>
                  </li>
                  <li class="li ul_li1 align_items_start">
                     <span class="li_title">死亡人数：</span>
                     <el-input clearable class="input" v-model="drugObj.deadNum" size="mini"></el-input>
                  </li>
               </ul>
               <ul class="ul">
                  <li class="li ul_li2 align_items_start">
                     <span class="li_title">首例用药日期：</span>
                     <el-date-picker v-model="drugObj.firstMadeDate" type="date" placeholder="选择日期" format="yyyy年MM月dd日" size="mini" value-format="yyyy-MM-dd"></el-date-picker>
                  </li>
                  <li class="li ul_li2 align_items_start">
                     <span class="li_title">首例发生日期：</span>
                     <el-date-picker v-model="drugObj.firstOccurDate" type="date" placeholder="选择日期" format="yyyy年MM月dd日" size="mini" value-format="yyyy-MM-dd"></el-date-picker>
                  </li>
               </ul>
               <div class="table" style="padding: 5px;">
                  <div class="btn align_items_center">
                     <el-button type="primary" size="mini" @click="addClick('hyypdetails')">新 增</el-button>
                     <el-button type="danger" size="mini" @click="delClick('hyypdetails','selectedDetailsIndex')">删 除</el-button>
                     <h3 style="margin-left: 10px;">怀 疑 药 品</h3>
                  </div>
                  <el-table :data="drugObj.hyypdetails" style="width: 100%" border height="300">
                     <el-table-column width="80" label="选择" fixed="left">
                        <template slot-scope="scope">
                           <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                           </el-radio>
                        </template>
                     </el-table-column>
                     <el-table-column prop="bgiGename" label="商品名称" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.bgiGename" size="mini"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="bgmName" label="通用名称" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable v-model="scope.row.bgmName" ref="bgmName" id="bgmName"
                                     @keyup.enter.native="openSearch(7067112496762880, scope.$index, 'bgmName', 'bgiGename,bgmName,bgmId,manufacturer,batchno,bgiAppnumber,spec', 'hyypdetails')">
                              <el-button @click="openSearch(7067112496762880, scope.$index, 'bgmName', 'bgiGename,bgmName,bgmId,manufacturer,batchno,bgiAppnumber,spec', 'hyypdetails')" slot="append"
                                         icon="el-icon-search">
                              </el-button>
                           </el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="manufacturer" label="生产企业" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.manufacturer" size="mini"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="spec" label="药品规格" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.spec" size="mini"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="batchno" label="生产批号" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.batchno" size="mini"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="bgiAppnumber" label="批准文号" min-width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.bgiAppnumber" size="mini"></el-input>
                        </template>
                     </el-table-column>
                  </el-table>
               </div>
               <div class="table" style="padding: 5px; border-top: 1px solid #000;">
                  <div class="btn align_items_center">
                     <el-button type="primary" size="mini" @click="addClick('hyqxdetails')">新 增</el-button>
                     <el-button type="danger" size="mini" @click="delClick('hyqxdetails','selectedDetailsIndex1')">删 除</el-button>
                     <h3 style="margin-left: 10px;">怀 疑 器 械</h3>
                  </div>
                  <el-table :data="drugObj.hyqxdetails" style="width: 100%" border height="300">
                     <el-table-column width="80" label="选择" fixed="left">
                        <template slot-scope="scope">
                           <el-radio v-model="selectedDetailsIndex1" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                           </el-radio>
                        </template>
                     </el-table-column>
                     <el-table-column prop="bgmName" label="产品名称" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable v-model="scope.row.bgmName" ref="bgmName" id="bgmName"
                                     @keyup.enter.native="openSearch(7067112496762880, scope.$index, 'bgmName', 'bgiGename,bgmName,bgmId,manufacturer,batchno,bgiRegistno', 'hyqxdetails')">
                              <el-button @click="openSearch(7067112496762880, scope.$index, 'bgmName', 'bgiGename,bgmName,bgmId,manufacturer,batchno,bgiRegistno', 'hyqxdetails')" slot="append" icon="el-icon-search">
                              </el-button>
                           </el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="manufacturer" label="生产企业" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.manufacturer" size="mini"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="batchno" label="生产批号" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.batchno" size="mini"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="bgiRegistno" label="注册号" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.bgiRegistno" size="mini"></el-input>
                        </template>
                     </el-table-column>
                  </el-table>
               </div>
               <p style="padding: 5px; border-top: 1px solid #000;">
                  <span class="li_title">不良事件表现：</span>
                  <el-input clearable style="margin-top: 5px;" v-model="drugObj.badPerfor" type="textarea" :rows="3" size="mini"></el-input>
               </p>
               <p style="padding: 5px;  border-top: 1px solid #000;">
                  <span class="li_title">群体不良事件过程描述及处理情况（可附页）：</span>
                  <el-input clearable style="margin-top: 5px;" v-model="drugObj.sameHand" type="textarea" :rows="5" size="mini"></el-input>
               </p>
               <ul class="ul">
                  <li class="li ul_li5 align_items_center" style="width: 150px;justify-content: center;flex-shrink: 0;">报告单位意见</li>
                  <li class="li ul_li5" style="width: 100%;">
                     <el-input clearable v-model="drugObj.repOpin" type="textarea" :rows="2" size="mini"></el-input>
                  </li>
               </ul>
               <ul class="ul">
                  <li class="li align_items_center" style="width: 150px;justify-content: center;flex-shrink: 0;">报告人信息</li>
                  <li class="li align_items_center" style="width: 100%;">
                     <span class="li_title">电话：</span>
                     <el-input clearable class="input" v-model="drugObj.userPhone" size="mini"></el-input>
                  </li>
                  <li class="li align_items_center" style="width: 100%;">
                     <span class="li_title">电子邮箱：</span>
                     <el-input clearable class="input" v-model="drugObj.userEmail" size="mini"></el-input>
                  </li>
                  <li class="li align_items_center" style="width: 100%;">
                     <span class="li_title">签名：</span>
                     <el-input clearable class="input" v-model="drugObj.repSign" size="mini"></el-input>
                  </li>
               </ul>
               <ul class="ul">
                  <li class="li ul_li6 align_items_center" style="width: 150px;justify-content: center;flex-shrink: 0;">报告单位信</li>
                  <li class="li ul_li6 align_items_center" style="width: 100%;">
                     <span class="li_title">报告单位：</span>
                     <el-input clearable class="input" v-model="drugObj.unitName" size="mini"></el-input>
                  </li>
                  <li class="li ul_li6 align_items_center" style="width: 100%;">
                     <span class="li_title">联系人：</span>
                     <el-input clearable class="input" v-model="drugObj.unitLink" size="mini"></el-input>
                  </li>
                  <li class="li ul_li6 align_items_center" style="width: 100%;">
                     <span class="li_title">电话：</span>
                     <el-input clearable class="input" v-model="drugObj.unitPhone" size="mini"></el-input>
                  </li>
               </ul>
            </div>
         </div>
         <div class="floor">
            <el-button type="primary" size="mini" @click="initActionBox">取消</el-button>
            <el-button type="primary" style="margin-left: 20px !important;" size="mini" @click="sendDataAction">保 存</el-button>
         </div>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import formList from './drug'
import SearchScheme from "../../byComponents/SearchScheme.vue";
export default {
   name: "drugInformation",
   //import引入的组件需要注入到对象中才能使用
   components: { SearchScheme },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {
            gchmType: '',
            page: 1,
            rows: 30,
            start: '',
            end: '',
            chanName: '',
            createrName: "",
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: []
         },

         buttonList: [],
         selectedDataIndex: 0,
         showStatus: false,
         actionData: {},
         formList: formList,
         DialogVisible: false,
         seId: "",
         seTitle: "",
         seWidth: "",
         parentSearchData: {},
         sField: "",
         //---------------药品不良反应/事件报告表
         drugShow: false,
         drugType: 0,
         tableType: "",
         selectedDetailsIndex: 0,
         selectedDetailsIndex1: 0,
         //怀疑药品
         hyypdetails: {
            "badType": 0,
            "batchno": "",
            "bgiAppnumber": "",
            "bgiGename": "",
            "bgiRegistno": "",
            "bgmName": "",
            "gbadId": 0,
            "id": 0,
            "manufacturer": "",
            "rowno": 0,
            "spec": ""
         },
         //怀疑器械
         hyqxdetails: {
            "badType": 1,
            "batchno": "",
            "bgiAppnumber": "",
            "bgiGename": "",
            "bgiRegistno": "",
            "bgmName": "",
            "gbadId": 0,
            "id": 0,
            "manufacturer": "",
            "rowno": 0,
            "spec": ""
         },
         drugObj: {
            "badNum": "",
            "badPerfor": "",
            "createTime": 0,
            "creater": 0,
            "deadNum": "",
            "firstMadeDate": "",
            "firstOccurDate": "",
            "gbadCode": "",
            "gbadId": 0,
            "hyqxdetails": [],
            "hyypdetails": [],
            "location": "",
            "ormId": 0,
            "repDate": "",
            "repOpin": "",
            "repSign": "",
            "sameHand": "",
            "sameRemark": "",
            "serBadNum": "",
            "unitLink": "",
            "unitName": "",
            "unitPhone": "",
            "useNum": "",
            "useUnit": "",
            "userEmail": "",
            "userPhone": ""
         }
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'getRequestData.gchmType': {
         handler: function (newValue, oldValue) {
            this.searchData()
         },
         deep: true,
      }
   },
   //方法集合
   methods: {
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         console.log(this.drugObj, "测试");

         if (field == "keydown") {
            return;
         }
         this.$nextTick(() => {
            if (this.$refs[field][index]) {
               this.$refs[field][index].focus();
            } else {
               this.$refs[field].focus();
            }
         })
      },
      initData() {
         for (const key in this.drugObj) {
            if (key == 'hyypdetails' || key == 'hyqxdetails') {
               this.drugObj[key] = []
            } else {
               this.drugObj[key] = ""
            }
         }
      },
      //取消
      initActionBox(val) {
         if (val) {
            this.getDataList()
         }
         this.drugShow = false
      },
      async sendDataAction() {
         let responseData;
         if (this.drugType == 0) {
            responseData = await this.$http.ymbadaddGroupBad(this.drugObj)
         } else if (this.drugType == 1) {
            responseData = await this.$http.ymbadupdGroupBad(this.drugObj)
         }
         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.initActionBox(true)
            this.initData()
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: { isPenetrate }, //参数
               },
               "*"
            );
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      // 检索Id, 索引(表格中), 标识ppamId
      openSearch(sId, index, type, sField, tableType) {
         this.DialogVisible = true;
         this.tableType = tableType
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            if (this.tableType == 'hyypdetails') {
               this.selectedDetailsIndex = this.seIndex
               this.drugObj[this.tableType][this.selectedDetailsIndex][item] = val[item]
            } else if (this.tableType == 'hyqxdetails') {
               this.selectedDetailsIndex1 = this.seIndex
               this.drugObj[this.tableType][this.selectedDetailsIndex1][item] = val[item]
            } else {
               this.getRequestData[item] = val[item]
            }
         })
         if (this.tableType == 'hyypdetails') {
            this.tableNextFocus('batchno', this.seIndex)
         } else if (this.tableType == 'hyqxdetails') {
            this.tableNextFocus('batchno1', this.seIndex)
         }
      },
      // 子组件触发
      drawerCancel(commitData) {
         this.showStatus = false
         commitData && this.getDataList()
      },
      getPageInfo() {
         this.getDataList()
      },
      lookDetail(data) {
         this.queryDetails(data)
      },
      async queryDetails(dataInfo) {
         const res = await this.$http.flowInstancequeryInfo({ ids: [dataInfo.wfiId] })
         if (res.status = 200) {
            let responseData = await this.$http.flowDeinitqueryDeinitionById({ ids: [dataInfo.wfdId] });
            if (responseData && responseData.status == 200) {
               this.actionData = {
                  cate: 2,
                  wfdId: dataInfo.wfdId,
                  wfiId: res.result.wfiId,
                  wdfForm: responseData.result.wdfForm,
                  wfiContent: res.result.wfiContent,
                  wfdName: res.result.wfdName,
                  wfiRemark: res.result.wfiRemark,
               }
               this.showStatus = true
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         }
      },
      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 0:
               this.initData()
               this.drugShow = true
               this.drugType = 0
               break;
            case 1:
               if (!this.returnData.list[this.selectedDataIndex]) {
                  this.$message({
                     message: '请先选择您要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               this.initData()
               var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
               for (const key in this.drugObj) {
                  if (dataInfo[key] != undefined && dataInfo[key] !== "" && dataInfo[key] != null) {
                     this.drugObj[key] = dataInfo[key];
                  }
               }
               this.drugShow = true
               this.drugType = 1
               break;
            case 2:
               if (!this.returnData.list[this.selectedDataIndex]) {
                  this.$message({
                     message: '请先选择您要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
               this.del(dataInfo)
               break;
         }
      },
      async del(dataInfo) {
         const responseData = await this.$http.ymbaddelGroupBad({ ids: [dataInfo.badId] })
         if (responseData.status == 200) {
            this.$message({
               message: "删除成功",
               type: "success",
            });
            this.getDataList()
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },


      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.ymbadqueryGroupBad(this.getRequestData)
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list
            this.returnData.pages = responseData.result.pages
            this.returnData.total = responseData.result.total
            this.returnData.pageNum = responseData.result.pageNum
            this.selectedDataIndex = 0
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
      },
      //---------------------------------
      addClick(val) {
         this.drugObj[val].push(JSON.parse(JSON.stringify(this[val])))
         if (val == 'hyqxdetails') {
            this.selectedDetailsIndex1 = this.drugObj[val].length - 1
            this.$nextTick(() => {
               this.tableNextFocus('bgmName1', this.selectedDetailsIndex1)
            })
         } else if (val == 'hyypdetails') {
            this.selectedDetailsIndex = this.drugObj[val].length - 1
            this.$nextTick(() => {
               this.tableNextFocus('bgmName', this.selectedDetailsIndex)
            })
         }
      },
      delClick(val, index) {
         this.drugObj[val].splice(this[index], 1)
         this[index] = 0
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      var objs = this.$common.getSearchData(this.formList.drugInformation, 'page', "rows", 30)
      for (const key in objs) {
         this.$set(this.getRequestData, key, objs[key])
      }
      this.getDataList()
      this.getButtonList()

   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
ul {
   list-style: none;
}
.box {
   padding: 10px;
}
.space_between {
   display: flex;
   align-items: center;
   justify-content: space-between;
}
.align_items_center {
   display: flex;
   align-items: center;
}
.align_items_start {
   display: flex;
}
.align_items_end {
   display: flex;
   align-items: center;
   justify-content: flex-end;
}
.marginTop {
   margin-top: 5px;
}
.box_center {
   border: 1px solid #000;
   margin-top: 5px;
}
.ul {
   display: flex;
}

.ul_li {
   width: calc(100vw / 3);
}
.ul_li1 {
   width: calc(100vw / 3);
}
.ul_li2 {
   width: calc(100vw / 2);
}
.ul_li3 {
   width: 100vw;
   border-top: 1px solid #000;
}
.ul_li4 {
   width: 100vw;
}
.ul_li5 {
   border-top: 1px solid #000;
}
.ul .li {
   text-align: center;
   padding: 5px;
   border-right: 1px solid #000;
   border-bottom: 1px solid #000;
}
.ul .ul_li6 {
   border-bottom: none;
}
.ul .li:last-child {
   border-right: none;
}
.li_title {
   flex-shrink: 0;
}
.table .btn {
   margin-bottom: 5px;
}
::v-deep .el-radio {
   margin-right: 10px;
}
::v-deep .el-radio__label {
   padding-left: 5px;
}
::v-deep .el-checkbox {
   margin-right: 10px;
}
::v-deep .el-checkbox__label {
   padding-left: 5px;
}
/* .input ::v-deep .el-input__inner{
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #000;
}
.input ::v-deep .el-input__inner:focus{
    border-bottom: 1px solid #409EFF;
} */
.floor_bottom {
   margin: 10px 30px;
   margin-top: 0;
}
.floor {
   display: flex;
   align-items: center;
   justify-content: center;
}
</style>